import React from "react";
import { CheckIcon } from "Components/Icons/CheckIcon";

interface StepIndicatorProps {
  currentStep: number;
}

export const StepIndicator = ({ currentStep }: StepIndicatorProps) => {
  const steps = [
    { id: 1, label: "Source" },
    { id: 2, label: "Competencies" },
    { id: 3, label: "Review" }
  ];

  return (
    <div className="step-indicator">
      <div className="steps-container">
        {steps.map((step, index) => (
          <React.Fragment key={step.id}>
            <div className={`step-item ${step.id <= currentStep ? "active" : ""}`}>
              <div className="step-circle">
                {step.id < currentStep ? (
                    <CheckIcon className="check-icon" />
                ) : (
                  step.id
                )}
              </div>
              <div className="step-label">
                {step.label}
                {step.id < currentStep && (
                  <span className="completed-text">Completed</span>
                )}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className={`step-line ${currentStep > index + 1 ? "active" : ""}`} />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};